import styled from 'styled-components';

import { createInputDisabledCSS } from 'ui/inputs/InputStyles';
import { colors, duration, easing, spacing } from 'ui/theme';
import { subtleShadow } from 'ui/theme/shadows';
import { body2 } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';

import { colorDeterminator } from '../helpers';

export const StyledInput = styled.input`
  ${body2};
  box-shadow: none; /** overrides global CSS on type="text" */
  box-sizing: border-box;
  border: none;
  display: block;
  flex: 1 1 auto;
  outline: none;
  color: inherit;

  :active {
    border: none;
  }
`;

export const StyledDateInput = styled(StyledInput)`
  width: ${pxToRem(92)};
  ${({ disabled }) => disabled && createInputDisabledCSS()};
`;

export const StyledRelativeDateInput = styled(StyledInput)`
  width: ${pxToRem(150)};
`;

export const StyledTimeInput = styled(StyledInput)<{ withTimeZone: boolean; isDisabled: boolean }>`
  width: ${(props) => (props.withTimeZone ? pxToRem(110) : pxToRem(75))};
  ${({ isDisabled }) => isDisabled && createInputDisabledCSS()};
`;

export const DatePickerWrapper = styled.div<InputWrapperProps>`
  display: flex;
  justify-content: flex-start;
  position: relative;
  border-radius: ${spacing.quarter};
  box-shadow: ${subtleShadow.boxShadow};
  padding: ${spacing.half} ${spacing.threeQuarter};
  border: ${spacing.single} solid;
  border-color: ${(props) => (props.isValid ? colors.grey15 : colors.negative100)};
  transition: all ${duration.short} ${easing.exit};
  background-color: ${(props) => (props.isDisabled ? colors.grey5 : colors.white)};
  width: 100%;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'default')};

  &:hover {
    border: ${spacing.single} solid ${colors.borderInteractive};
    transition: all ${duration.short} ${easing.entrance};
  }

  & > *,
  & > * > * {
    background-color: ${(props) => (props.isDisabled ? colors.grey5 : colors.white)};
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  }

  &:focus-within {
    border: ${spacing.single} solid ${colors.borderInteractive};
    box-shadow: 0 0 0 ${spacing.single} ${colors.borderInteractive};
  }
`;

type InputWrapperProps = {
  isValid?: boolean;
  isFocused?: boolean;
  isDisabled?: boolean;
};

export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  color: ${(props) => colorDeterminator(props.isValid, props.isFocused, props.isDisabled)};
  ${({ isDisabled }) => isDisabled && createInputDisabledCSS()};
`;
